import {
	Box,
	Grid,
	FormControl,
	Select,
	MenuItem,
	InputLabel,
	Button,
	Typography,
	TextField,
	InputAdornment,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import { sizes } from "../../setupUtils";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	getPGDetail,
	getPGForCountry,
	resetAllStates,
	setPGState,
} from "../productGroupSetupSlice";
import Status from "./Status";
import CollapseSection from "../../../../components/ui/CollapseSection";

export default function SearchPG() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const dispatch = useDispatch();

	const {
		countries,
		country,
		countryID,
		productGroups,
		productGroupName,
		eProductGroupName,
		productGroupID,
		productGroup,
		fromDate,
		toDate,
		status,
      selectedSKUs
	} = pgState;

   const minDate = dayjs().add(1, 'day');
   
	useEffect(() => {
		if (countryID !== "") {
			dispatch(getPGForCountry({ countryID, productGroupName }));
			dispatch(setPGState("productGroupName", ""));
		}
	}, [countryID]);

	useEffect(() => {
		if (productGroup !== null && Object.keys(productGroup).length > 0) {
			setPGDetails();
		}
	}, [productGroup]);

	function updateCountry(event) {
      dispatch(resetAllStates({ edit: true }));
		const name = event.target.value;
		const id = countries.find(
			(country) => country.countryName === name
		).countryID;
		dispatch(setPGState("country", name));
		dispatch(setPGState("countryID", id));
	}

	function updateProductGroup(event) {
		const pg = event.target.value;
		const pgID = productGroups.find(
			(pgroup) => pgroup.productGroupName === pg
		).productGroupID;
		dispatch(setPGState("productGroupName", pg));
		dispatch(setPGState("productGroupID", pgID));
		dispatch(setPGState("is_refresh", true));
		dispatch(setPGState("selectedSKUs", []));
		dispatch(setPGState("skus", []));
	}

	function getDetailPG() {
      const id = productGroupID;
      // reset all states when go button is clicked. 
      dispatch(setPGState("eProductGroupName", ""));
      dispatch(setPGState("fromDate", dayjs().add(1, "day")));
      dispatch(setPGState("toDate", dayjs("2099-12-31T00:00:00.000Z")));
      dispatch(setPGState("status", "None"));
      dispatch(setPGState("searchedPGName", ""));
      dispatch(setPGState("skus", []));
      dispatch(setPGState("selectedSKUs", []));
      dispatch(setPGState("comments", ""));
      dispatch(setPGState("files", []));

      if(!id) {
         dispatch(setPGState("editMessage", "No product group selected"));
         dispatch(setPGState("editMessageSeverity", "info"));
         dispatch(setPGState("editMessageOpen", true));
         return;
      }
		dispatch(getPGDetail({ productGroupID: id }));
	}

	function setPGDetails() {
		dispatch(setPGState("eProductGroupName", productGroup.productGroupName));
		dispatch(setPGState("fromDate", dayjs(productGroup.effectiveStartDate)));
		dispatch(setPGState("toDate", dayjs(productGroup.effectiveEndDate)));
		dispatch(setPGState("status", productGroup.status));
		dispatch(setPGState("skus", []));
		dispatch(setPGState("selectedSKUs", productGroup.productGroupList));
		dispatch(setPGState("comments", productGroup.comments));
		dispatch(setPGState("files", productGroup.productGroupFiles));
	}

	function updateEditPGName(event) {
		const name = event.target.value;
		dispatch(setPGState("eProductGroupName", name));
	}

	function updateFromDate(newDate) {
		dispatch(setPGState("fromDate", newDate));
      setSelectedSKUFromDates(newDate);
	}

	function updateToDate(newDate) {
		dispatch(setPGState("toDate", newDate));
      setSelectedSKUTODates(newDate);
	}

   function setSelectedSKUFromDates(date) {
      const selSKUs = selectedSKUs.map((item) => {
         return {
            ...item,
            effectiveStartDate: date, 
         };
      });
      dispatch(setPGState("selectedSKUs", selSKUs));
   }

   function setSelectedSKUTODates(date) {
      const selSKUs = selectedSKUs.map((item) => {
         return {
            ...item,
            effectiveEndDate: date, 
         };
      });
      dispatch(setPGState("selectedSKUs", selSKUs));
   }

	return (
		<Box>
			{/* COUNTRY, PRODUCT GROUP NAME, GO BUTTON */}
			<Box
				sx={{
					mt: 3,
				}}
			>
				<Grid container columns={7} spacing={2} rowGap={2}>
					<Grid item sm={2} md={3} lg={3.15}>
						<FormControl>
							<InputLabel>Country</InputLabel>
							<Select
								value={country}
								label="Country"
								sx={{
									height: sizes.h35,
									width: sizes.w270,
									color: "black.main",
									mt: 1,
								}}
								onChange={updateCountry}
							>
								{countries.map((country, index) => {
									return (
										<MenuItem key={index} value={country.countryName}>
											{country.countryName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Grid>

					<Grid item sm={3.15}>
						<FormControl>
							<InputLabel>Product Group Name</InputLabel>
							<Select
								value={productGroupName}
								label="Product Group Name"
								sx={{
									height: sizes.h35,
									width: sizes.w270,
									color: "black.main",
									mt: 1,
								}}
								onChange={updateProductGroup}
							>
								{productGroups.length > 0 ? (
									productGroups.map((pg, index) => {
										return (
											<MenuItem
												key={index}
												value={pg.productGroupName}
											>
												{pg.productGroupName}
											</MenuItem>
										);
									})
								) : (
									<MenuItem value={""}>--No Item--</MenuItem>
								)}
							</Select>
						</FormControl>
					</Grid>

					<Grid item sm={.7}>
						<Button
							startIcon={<KeyboardArrowRightIcon />}
							sx={{
								bgcolor: "blue.main",
								color: "white.main",
								textTransform: "none",
								"&:hover": {
									bgcolor: "lightBlue.main",
								},
							}}
							onClick={getDetailPG}
						>
							<Typography
								sx={{ fontWeight: "bold", color: "white.main" }}
							>
								Go
							</Typography>
						</Button>
					</Grid>
				</Grid>
			</Box>

			{/* PRODUCT GROUP NAME, FROM DATE, TO DATE, STATUS */}
			<Box sx={{ mt: 3, }}>
			{/* <Typography className="compHeading"
					sx={{ fontWeight: "bold", color: "blue.main", mb: 2, }}
					gutterBottom
				>
					Define Product Group Parameters
				</Typography> */}
				<CollapseSection title="Define Product Group Parameters">
				<Grid container spacing={3} columns={12} sx={{mt: 1}}>
					<Grid item sm={6} md={6} lg={4}>
						<TextField
							label="Product Group Name"
							InputProps={{
								startAdornment: (
									<InputAdornment position="end">
										<EditIcon />
									</InputAdornment>
								),
							}}
                     disabled
							variant="outlined"
							value={eProductGroupName}
							onChange={updateEditPGName}
						/>
					</Grid>

					<Grid item sm={6} md={6} lg={3}>
						<Box>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
                           			disabled
									label="From"
									value={fromDate}
									onChange={(newValue) => updateFromDate(newValue)}
									renderInput={(params) => (
										<TextField
											{...params}
											size="small"
											sx={{ width: sizes.w200 }}
										/>
									)}
									format="DD/MM/YYYY"
								/>
							</LocalizationProvider>
						</Box>
					</Grid>

					<Grid item sm={6} md={6} lg={3}>
						<Box>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
                           			minDate={minDate}
									disabled = {productGroup?.isDeactivated == 1? true: false}
									label="To"
									value={toDate}
									onChange={(newValue) => updateToDate(newValue)}
									renderInput={(params) => (
										<TextField
											{...params}
											size="small"
											sx={{ width: sizes.w200 }}
										/>
									)}
									format="DD/MM/YYYY"
								/>
							</LocalizationProvider>
						</Box>
					</Grid>

					<Grid item sm={6} md={6} lg={2}>
						<Status label={status} />
					</Grid>
				</Grid>
				</CollapseSection>
			</Box>
		</Box>
	);
}
